import { Product } from '@mews-commander/data-access';

export enum AutomationTag {
    CurrentAutomation = 'CurrentAutomation',
    NewAutomation = 'NewAutomation',
}

export type LocalizedProduct = Product & { localizedName: string };
